
export default function ServicesSection() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Consumer Debt Card */}
          <div id="consumer-debt" className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="bg-gradient-to-r from-slate-600 to-teal-600 px-6 py-4">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
                  <i className="fas fa-user text-teal-600"></i>
                </div>
                <h3 className="text-white text-xl font-semibold">Consumer Debt Relief</h3>
              </div>
            </div>
            
            <div className="p-8">
              <div className="mb-6">
                <img 
                  src="https://public.readdy.ai/ai/img_res/869329aa354c72de8ab9545eaec54c58.jpg"
                  alt="Consumer Debt Relief"
                  className="w-full h-48 object-cover rounded-lg"
                />
              </div>
              
              <h4 className="text-2xl font-bold text-gray-900 mb-4">Credit Card & Personal Debt Solutions</h4>
              
              <ul className="space-y-3 mb-8">
                <li className="flex items-start space-x-3">
                  <div className="w-5 h-5 bg-orange-500 rounded-full flex items-center justify-center mt-0.5">
                    <i className="fas fa-check text-white text-xs"></i>
                  </div>
                  <span className="text-gray-700">Credit card debt settlement up to 60% reduction</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-5 h-5 bg-orange-500 rounded-full flex items-center justify-center mt-0.5">
                    <i className="fas fa-check text-white text-xs"></i>
                  </div>
                  <span className="text-gray-700">Personal loan negotiation and settlement</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-5 h-5 bg-orange-500 rounded-full flex items-center justify-center mt-0.5">
                    <i className="fas fa-check text-white text-xs"></i>
                  </div>
                  <span className="text-gray-700">Medical bill resolution and payment plans</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-5 h-5 bg-orange-500 rounded-full flex items-center justify-center mt-0.5">
                    <i className="fas fa-check text-white text-xs"></i>
                  </div>
                  <span className="text-gray-700">Stop harassing collection calls immediately</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-5 h-5 bg-orange-500 rounded-full flex items-center justify-center mt-0.5">
                    <i className="fas fa-check text-white text-xs"></i>
                  </div>
                  <span className="text-gray-700">No upfront fees - pay only when we settle</span>
                </li>
              </ul>
              
              <button 
                onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                className="text-teal-600 hover:text-teal-700 font-semibold flex items-center space-x-2 transition-colors duration-300"
              >
                <span>Learn More</span>
                <i className="fas fa-arrow-right"></i>
              </button>
            </div>
          </div>

          {/* Business Debt Card */}
          <div id="business-debt" className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="bg-gradient-to-r from-slate-700 to-orange-600 px-6 py-4">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
                  <i className="fas fa-briefcase text-orange-600"></i>
                </div>
                <h3 className="text-white text-xl font-semibold">Business Debt Settlement</h3>
              </div>
            </div>
            
            <div className="p-8">
              <div className="mb-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20business%20owner%20at%20modern%20office%20desk%20with%20declining%20debt%20chart%20turning%20into%20positive%20growth%20arrow%2C%20laptop%20and%20financial%20documents%20showing%20business%20debt%20relief%20success%2C%20clean%20corporate%20environment&width=400&height=300&seq=business-001&orientation=landscape"
                  alt="Business Debt Settlement"
                  className="w-full h-48 object-cover rounded-lg"
                />
              </div>
              
              <h4 className="text-2xl font-bold text-gray-900 mb-4">Merchant Cash Advance & Business Loan Relief</h4>
              
              <ul className="space-y-3 mb-8">
                <li className="flex items-start space-x-3">
                  <div className="w-5 h-5 bg-orange-500 rounded-full flex items-center justify-center mt-0.5">
                    <i className="fas fa-check text-white text-xs"></i>
                  </div>
                  <span className="text-gray-700">Merchant cash advance debt restructuring</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-5 h-5 bg-orange-500 rounded-full flex items-center justify-center mt-0.5">
                    <i className="fas fa-check text-white text-xs"></i>
                  </div>
                  <span className="text-gray-700">Business loan settlement and negotiation</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-5 h-5 bg-orange-500 rounded-full flex items-center justify-center mt-0.5">
                    <i className="fas fa-check text-white text-xs"></i>
                  </div>
                  <span className="text-gray-700">UCC lien removal and asset protection</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-5 h-5 bg-orange-500 rounded-full flex items-center justify-center mt-0.5">
                    <i className="fas fa-check text-white text-xs"></i>
                  </div>
                  <span className="text-gray-700">Stop aggressive collection tactics</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-5 h-5 bg-orange-500 rounded-full flex items-center justify-center mt-0.5">
                    <i className="fas fa-check text-white text-xs"></i>
                  </div>
                  <span className="text-gray-700">Customized payment plans for your business</span>
                </li>
              </ul>
              
              <button 
                onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                className="text-teal-600 hover:text-teal-700 font-semibold flex items-center space-x-2 transition-colors duration-300"
              >
                <span>Explore Solutions</span>
                <i className="fas fa-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
